/*
 * @Author: Dong
 * @Date: 2022-04-20 11:14:22
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-05-06 10:49:35
 */
import { UpdateQueueType } from 'root/components/FileConfig/types';
import {
  CHANGE_TAB,
  UPDATE_QUEUE,
  ADD_QUEUE,
  SELECT_VERSION,
  CLEAR_FILE_CONFIG,
  CHAGNE_FORM,
  CHANGE_SYSTEM,
  SET_SOURCE_DATA,
  SET_UPDATE_METHOD,
} from '../constant';
import { fileConfigStatus } from './types';

const defaultStates: fileConfigStatus = {
  tab: 'local',
  queueState: {
    current: '',
    queue: [],
  },
  selectedVersions: {}, // 所选的扩展组件
  formData: {}, // 扩展组件的表单信息
  systemInfo: {}, // 选择的系统包
  updateMethodList: [], // 升级模式
  sourceData: [], // 源数据,用于对比是否选中必须的数据
};

const page = (state = { ...defaultStates }, action: any) => {
  const { current, queue } = state.queueState;
  const { type, payload } = action;

  switch (type) {
    // 清空数据
    case CLEAR_FILE_CONFIG: {
      return {
        ...defaultStates,
      };
    }
    // 切换页签
    case CHANGE_TAB: {
      return {
        ...state,
        tab: payload.tab,
      };
    }
    // 选择版本
    case SELECT_VERSION: {
      const temp = { ...state.selectedVersions, ...payload };
      const newSelectedVersions: { [x: string]: string } = {};
      Object.keys(temp).forEach((key) => {
        if (!temp[key]) return;
        newSelectedVersions[key] = temp[key];
      });

      return {
        ...state,
        selectedVersions: {
          ...newSelectedVersions,
        },
      };
    }
    // 添加上传队列
    case ADD_QUEUE: {
      const newQueue = queue.concat(payload.queue);

      return {
        ...state,
        queueState: {
          current: !current ? newQueue.find((item) => item.status === 'waiting')?.name : current,
          queue: newQueue,
        },
      };
    }
    // 更新任务
    case UPDATE_QUEUE: {
      const { name, uploadPrecent, path } = payload;

      let newCurrent = current;

      const newQueue = queue.map((item: UpdateQueueType) => {
        const newItem = { ...item };
        // 正在上传的包
        if (item.name === name) {
          newItem.uploadPrecent = uploadPrecent;

          // 进度100%,进度改成success
          if (uploadPrecent === 100) {
            newItem.status = 'success';
            if (path) {
              newItem.path = path;
            }

            // 激活下一个组件上传
            newCurrent = queue.find((item) => item.status === 'waiting')?.name || '';
          } else {
            // 上传中,更新状态
            if (item.status !== 'uploading') {
              newItem.status = 'uploading';
            }
          }

          return newItem;
        }

        // 还未上传,状态改成wait
        if (item.status === 'unUpload') {
          newItem.status = 'waiting';
          return newItem;
        }

        return newItem;
      });

      return {
        ...state,
        queueState: {
          current: newCurrent,
          queue: newQueue,
        },
      };
    }
    // 删除队列
    case 'deleteQueue': {
      const newQueue = queue.filter((item) => item.name !== payload.name);
      const newCurrent = current === payload.name ? '' : current;

      return {
        ...state,
        queueState: {
          current: newCurrent,
          queue: newQueue,
        },
      };
    }
    case CHAGNE_FORM: {
      return {
        ...state,
        formData: payload,
      };
    }
    case CHANGE_SYSTEM: {
      return {
        ...state,
        systemInfo: payload,
      };
    }
    case SET_SOURCE_DATA: {
      return {
        ...state,
        sourceData: payload,
      };
    }
    case SET_UPDATE_METHOD: {
      return {
        ...state,
        updateMethodList: payload,
      };
    }

    default:
      return state;
  }
};

export default page;
